module.exports = __webpack_public_path__ + "img/paytm.f8aaedf6.svg";